export default {
  setContainers(state, payload) {
    state.containers = payload;
  },
  setContainersV2(state, payload) {
    state.containersV2 = payload;
    // console.log("setContainersV2--payload", state.containersV2)
  },
  setContainer(state, payload) {
    // console.log("SET CONTAINER", payload);
    state.container = payload;
  },
  setGridContainers(state, payload) {
    state.gridContainers = payload;
  },
  setSelectedContainer(state, payload) {
    state.selectedContainer = payload;
  },
  setContainerHistory(state, payload) {
    state.containerHistory = payload;
  },
  setContainerHistoryDetail(state, payload) {
    state.containerHistoryDetail = payload;
  },
  setContainerPropertyHistory(state, payload) {
    state.containerPropertyHistory = payload;
  },
  setContainersStatus(state, payload) {
    state.containersStatus = payload;
  },
  setContainerStatus(state, payload) {
    state.containerStatus = payload;
  },
  setContainerProps(state, payload) {
    state.containerProps = payload;
  },
  updateContainerProperties(state, payload) {
    state.containersV2.filter((x) => x.containerId == payload.containerId)[0][
      payload.propertyName.toLowerCase()
    ] = payload.propValue;
  },
  setContainersStatusFilter(state, payload) {
    state.containersStatusFilter = payload;
  },
  setContainersFilteredList(state, payload) {
    state.containersFilteredIds = payload;
  },
  setMapContainers(state, containers) {
    state.mapContainers = containers;
  },

  updateContainerLocation(state, { containerId, latitude, longitude }) {
    // Update in main containers array
    const container = state.containers.find(
      (c) => c.containerId === containerId
    );
    if (container) {
      container.latitude = latitude;
      container.longitude = longitude;
    }
    // Update in map containers array
    const mapContainer = state.mapContainers.find((c) => c.id === containerId);
    if (mapContainer) {
      mapContainer.position = { lat: latitude, lng: longitude };
    }
  },


  updateContainerName(state, { containerId, containerName }) {
    if (state.containers && state.containers.length > 0) {
      const container = state.containers.find(
        (c) => c.containerId === containerId
      );
      if (container) {
        // eslint-disable-next-line no-prototype-builtins
        if(container.hasOwnProperty('containerName'))
          container.containerName = containerName;
        // eslint-disable-next-line no-prototype-builtins
        if(container.hasOwnProperty('surface'))
          container.surface = containerName;
      }
    }

    if (state.containersV2 && state.containersV2.length > 0) {
      const container = state.containersV2.find(
        (c) => c.containerId === containerId
      );
      if (container) {
        // eslint-disable-next-line no-prototype-builtins
        if(container.hasOwnProperty('containerName'))
          container.containerName = containerName;
        // eslint-disable-next-line no-prototype-builtins
        if(container.hasOwnProperty('surface'))
          container.surface = containerName;
      }
    }

    if (state.containersStatus && state.containersStatus.length > 0) {
      const container = state.containersStatus.find(
        (c) => c.containerId === containerId
      );
      if (container) {
        // eslint-disable-next-line no-prototype-builtins
        if(container.hasOwnProperty('containerName'))
          container.containerName = containerName;
        // eslint-disable-next-line no-prototype-builtins
        if(container.hasOwnProperty('surface'))
          container.surface = containerName;
      }
    }

    if (state.gridContainers && state.gridContainers.length > 0) {
      const container = state.gridContainers.find(
        (c) => c.containerId === containerId
      );
      if (container) {
        // eslint-disable-next-line no-prototype-builtins
        if(container.hasOwnProperty('containerName'))
          container.containerName = containerName;
        // eslint-disable-next-line no-prototype-builtins
        if(container.hasOwnProperty('surface'))
          container.surface = containerName;
      }
    }

    if (state.container && state.container.containerId === containerId) {
      // eslint-disable-next-line no-prototype-builtins
      if(state.container.hasOwnProperty('containerName'))
        state.container.containerName = containerName;
      // eslint-disable-next-line no-prototype-builtins
      if(state.container.hasOwnProperty('surface'))
        state.container.surface = containerName;
    }

    if (
      state.containerStatus &&
      state.containerStatus.containerId === containerId
    ) {
      // eslint-disable-next-line no-prototype-builtins
      if(state.containerStatus.hasOwnProperty('containerName'))
        state.containerStatus.containerName = containerName;
      // eslint-disable-next-line no-prototype-builtins
      if(state.containerStatus.hasOwnProperty('surface'))
        state.containerStatus.surface = containerName;
    }

    if (
      state.selectedContainer &&
      state.selectedContainer.containerId === containerId
    ) {
      // eslint-disable-next-line no-prototype-builtins
      if(state.selectedContainer.hasOwnProperty('containerName'))
        state.selectedContainer.containerName = containerName;
      // eslint-disable-next-line no-prototype-builtins
      if(state.selectedContainer.hasOwnProperty('surface'))
        state.selectedContainer.surface = containerName;
    }

    const mapContainer = state.mapContainers.find((c) => c.id === containerId);
    if (mapContainer) {
      // eslint-disable-next-line no-prototype-builtins
      if(mapContainer.containerName.hasOwnProperty('containerName'))
        mapContainer.containerName.containerName = containerName;
      // eslint-disable-next-line no-prototype-builtins
      if(mapContainer.containerName.hasOwnProperty('surface'))
        mapContainer.containerName.surface = containerName;
    }

    // console.log("updateContainerName",state.containersV2)
  },
  updateMapContainerStatus(state, { containerId, status }) {
    const container = state.mapContainers.find((c) => c.id === containerId);
    if (container) {
      container.status = status;
    }
  },
  setMapFilters(state, filters) {
    state.mapFilters = { ...state.mapFilters, ...filters };
  },
  setContainerNotes(state, payload) {
    state.containerNotes = payload;
  },
  addContainerNote(state, payload) {
    state.containerNotes.push(payload);
  },
  setResponseCode(state, payload) {
    state.responseCode = payload;
  },
  setContainerHistoryExtended(state, payload) {
    state.containerExtendedHistory = payload;
  },
};
